export default __webpack_public_path__ + "static/media/magicalfunpark.5d66a4f3.jpg";